import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

class UnsubscribeModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices',
        '$timeout'
    ];

    private close: any;
    private dismiss: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService
    ) {
        $scope.unsubscribe = false;
        $scope.ok = () => {
            $scope.unsubscribe = true;
            this.close({ $value: $scope.unsubscribe });
        };
        $scope.cancel = () => {
            this.dismiss({ $value: 'cancel' });
        };
    }
}

export const UnsubscribeModalComponent: ng.IComponentOptions = {
    template: require('./unsubscribe-modal.html'),
    controller: UnsubscribeModalController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/unsubscribe-modal/unsubscribe-modal.ts